import { ReactNode } from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";

interface IModernInfoItem {
  icon?: ReactNode;
  label: string;
  value?: string | null;
}

export const ModernInfoItem = ({ icon, label, value }: IModernInfoItem) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const borderColor = alpha(primaryColor, 0.22);

  return (
    <Box
      sx={{
        minWidth: "180px",
        flex: "1 1 180px",
        p: 1.25,
        borderRadius: "10px",
        backgroundColor: alpha(primaryColor, 0.08),
        border: `1px solid ${borderColor}`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.6,
          color: "text.primary",
          mb: 0.5,
        }}
      >
        {icon}
        <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary" }}>
          {label}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 700, color: "text.primary" }}>
        {value || "-"}
      </Typography>
    </Box>
  );
};
